'use client';

import { c as _c } from "react/compiler-runtime";
import { useDetailedNavigation } from '@/components/DetailedView/DetailedNavigationProvider';
import { MetricCard, StatisticCard } from '@/components/Metrics/MetricCard';
import { DataGroup } from '@/payload/blocks/TopicBlock/DataGroup';
import { structureLinkedDocs } from '@/payload/blocks/TopicBlock/utils';
import { api } from '@/trpc/react';
import React from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
export const LastUpdated = t0 => {
  const $ = _c(11);
  const {
    types,
    limit,
    draft,
    enabled
  } = t0;
  const {
    setNavigationData
  } = useDetailedNavigation();
  let t1;
  if ($[0] !== limit || $[1] !== types) {
    t1 = {
      limit,
      types
    };
    $[0] = limit;
    $[1] = types;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = enabled && !!types && !!limit;
  let t3;
  if ($[3] !== t2) {
    t3 = {
      enabled: t2,
      staleTime: Infinity
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data,
    isPending
  } = api.metrics.getLastUpdated.useQuery(t1, t3);
  if (isPending) {
    const t4 = limit || 4;
    let t5;
    if ($[5] !== t4) {
      t5 = new Array(t4).fill(0).map(_temp);
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  let t4;
  if ($[7] !== data || $[8] !== draft || $[9] !== setNavigationData) {
    const structuredData = data?.data ? structureLinkedDocs(data.data, draft) : [];
    const handleClick = function handleClick(id) {
      setNavigationData(structuredData.map(_temp2), id);
    };
    t4 = structuredData.map((doc_0, index_0) => {
      if (doc_0.type === "metrics") {
        return <MetricCard onClick={() => {
          handleClick(doc_0.raw.id);
        }} key={`metric-${index_0}`} parsedMetric={doc_0.value} rawMetric={doc_0.raw} />;
      }
      if (doc_0.type === "statistics") {
        return <StatisticCard onClick={() => {
          handleClick(doc_0.raw.id);
        }} key={`metric-${index_0}`} data={doc_0.value} />;
      }
      return <DataGroup onClick={id_0 => {
        handleClick(id_0);
      }} key={`group-${index_0}`} orderIndex={doc_0.orderIndex} docs={doc_0.value} />;
    });
    $[7] = data;
    $[8] = draft;
    $[9] = setNavigationData;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const LastUpdatedComponent = props => {
  const $ = _c(6);
  const [ref, isIntersecting] = useIntersectionObserver();
  let t0;
  if ($[0] !== isIntersecting || $[1] !== props) {
    t0 = <LastUpdated enabled={isIntersecting} {...props} />;
    $[0] = isIntersecting;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== ref || $[4] !== t0) {
    t1 = <div ref={ref} className="grid grid-cols-1 p-2 md:p-0 md:grid-cols-2 xl:grid-cols-3 mt-2">{t0}</div>;
    $[3] = ref;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp(_, index) {
  return <MetricCard key={`metric-${index}`} parsedMetric={undefined} rawMetric={undefined} isLoading={true} />;
}
function _temp2(doc) {
  return {
    type: doc.type === "metrics" ? "metric" : "statistic",
    id: doc.raw.id
  };
}